<template>
  <div class="dialog">
    <!-- 抓图上报隐患 -->
    <el-dialog
      :append-to-body="false"
      :modal-append-to-body="false"
      title="上报隐患 "
      :visible.sync="drawer"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      custom-class="capture-report-dialog"
      center
    >
      <div class="capture-body">
        <div class="capture-close" @click="closeAddHiddenDanger()">关闭</div>
        <div class="capture-title">
          <div class="carture-icon"></div>
          <div class="capture-title-txt"></div>
        </div>
        <div class="capture-content">
          <div class="icon-list">
            <img src="@/assets/img/schoolMonitorCenter/report-dailog-list-icon.png" alt="">
          </div>
          <div class="content-list">
            <div class="list-label">
              <div class="list-name">学校名称：</div>
              <div class="list-select">负责人：</div>
              <div class="list-address">隐患位置：</div>
              <div class="list-description">隐患描述：</div>
              <div class="list-img">隐患图片：</div>
            </div>
            <div class="list-info">
              <div class="list-name">{{ $store.state.schoolInfo.schoolName }}</div>
              <div class="list-select">
                <template>
                  <el-select 
                   :popper-append-to-body="false"
                    v-model="temporaryData.personId" 
                    @change="selectPerson()"
                    placeholder="请选择">
                      <el-option label="请选择" :value="0"></el-option>
                      <el-option v-for="value in personList" :key="value.userId" :value="value.userId" :label="value.userName"></el-option>
                  </el-select>
                </template>
              </div>
              <div class="list-address">
                <input type="text" placeholder="请上报隐患位置" v-model.trim="insertData.hiddenDangerPosition" autocomplete="off">
              </div>
              <div class="list-description">
                <textarea
                  class=""
                  v-model.trim="insertData.hiddenDangerDescribe"
                  placeholder="请上报隐患详情"
                ></textarea>
              </div>
              <div class="list-img">
                <el-image 
                  v-if="insertData.hiddenDangerImgUrl"
                  style="width: 178px; height: 90px"
                  :src="$store.state.config.fileUrl + insertData.hiddenDangerImgUrl" 
                  :preview-src-list="[$store.state.config.fileUrl + insertData.hiddenDangerImgUrl]">
                </el-image>
              </div>
              <div class="capture-button" @click="reportHiddenDanger">上报隐患</div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "captureReportHidden",
  components: {},
  props: {
    captureImg: {
      type: String,
      default: {
        return: "",
      },
    },
  },
  data() {
    return {
      personList: [], // 负责人列表
      // 临时数据
      temporaryData: {
        personName: "", // 负责人姓名
        personId: "", // 负责人ID
      },
      insertData: {
        hiddenDangerImgUrl: "",
        hiddenDangerDescribe: "",
        reportUserName: "",
        hiddenDangerPosition: "",
        principalName: "",
        schoolId: this.$store.state.schoolId,
      },
      drawer: false,
    };
  },
  created() {},
  mounted() {},
  computed: {},
  watch: {
    captureImg(newVal) {
      if (newVal) {
        this.insertData.hiddenDangerImgUrl = newVal;
        this.openAddHiddenDanger();
      }
    },
  },
  methods: {
    openAddHiddenDanger() {
      this.getHiddenDangerPerson();
      this.drawer = true;
    },

    closeAddHiddenDanger() {
      this.insertData.hiddenDangerImgUrl = "";
      this.insertData.hiddenDangerDescribe = "";
      this.insertData.hiddenDangerPosition = "";
      this.insertData.principalName = "";
      this.drawer = false;
    },

    // 获取隐患 负责人
    async getHiddenDangerPerson() {
      var requestData = {
        schoolId: this.$store.state.schoolId,
      };
      let res = await this.$Http.getHiddenDangerPerson(requestData, true);
      if (res.code == 200) {
        this.personList = res.data;
        if (this.personList.length >= 1) {
          this.isPersonData = true;
          return false;
        }

        this.$message({
          type: "error",
          message: "暂无处理人/负责人数据",
        });

        // this.dialog = true;
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage,
        });
      }
    },

    // 选择负责人
    selectPerson() {
      this.personList.forEach(element => {
        if(element.userId == this.temporaryData.personId){
          this.temporaryData.personName = element.userName
          this.temporaryData.personId = element.userId

          this.insertData.principalName = element.userName + "_" + element.userId;
          // console.log(this.insertData)
          return false
        }
      });
    },

    // 上报隐患
    async reportHiddenDanger() {
      let userInfo = JSON.parse(sessionStorage.getItem('userInfo'));
      this.insertData.reportUserName = userInfo.userName  + '_' + userInfo.userId;
      let req = this.insertData;
      // console.log(req)
      if(req.principalName == ''){
        this.$message('请选择负责人！');
        return;
      }
      if(req.hiddenDangerPosition == ''){
        this.$message('请填写隐患位置！');
        return;
      }
      if(req.hiddenDangerDescribe == ''){
        this.$message('请填写隐患详情！');
        return;
      }
      let res = await this.$Http.reportHiddenDanger(req, true);
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: "上报成功",
        });
        this.closeAddHiddenDanger();
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage,
        });
      }
    },
  },
  destroyed() {},
};
</script>
<style lang="scss" scoped>
.dialog {
  /deep/ .el-dialog {

    background: transparent !important;
  }
}
.capture-report-dialog {
  .capture-body {
    width: 908px;
    height: 600px;
    // 已修改
    background: url("~@/assets/img/hiddenDangerNow/hidden-detail-dialog-bg.png") center center no-repeat;
    background-size: 100% 100%;
    position: relative;
  }
  .capture-close{
    width: 56px;
    height: 24px;
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #d7deff;
    text-align: center;
    line-height: 25px;
    letter-spacing: 1px;
    position: absolute;
    top: 20px;
    right: 20px;
    cursor: pointer;
  }
  .capture-title{
    display: flex;
    justify-content: center;
    align-items: center;
    .carture-icon{
      width: 64px;
      height: 64px;
      background: url("~@/assets/img/schoolMonitorCenter/capture-dialog-title-icon.png") center center no-repeat;
      background-size: 100% 100%;
    }
    .capture-title-txt{
      width: 81px;
      height: 20px;
      background: url("~@/assets/img/schoolMonitorCenter/capture-dialog-title-txt.png") center center no-repeat;
      background-size: 100% 100%;
    }
  }
  .capture-content{
    display: flex;
    justify-content: center;
    .icon-list{
      margin-right: 35px;
    }
    .content-list{
      width: 440px;
      display: flex;
      justify-content: center;
      .list-label{
        div{
          width: 95px;
          font-size: 18px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #FFFFFF;
          line-height: 25px;
          letter-spacing: 1px;
          text-align: right;
          &.list-name{
            margin-top: 56px;
          }
          &.list-select{
            margin-top: 40px;
          }
          &.list-address{
            margin-top: 42px;
          }
          &.list-description{
            margin-top: 47px;
          }
          &.list-img{
            margin-top: 70px;
          }
        }
      }
      .list-info{
        div{
          width: 300px;
          &.list-name{
            margin-top: 56px;
            min-height: 40px;
            font-size: 18px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #D7DEFF;
            line-height: 25px;
            letter-spacing: 1px;
            padding-bottom: 8px;
            border-bottom: 1px solid rgba(120, 125, 233, 0.4);
          }
          &.list-select{
            margin-top: 24px;
            .el-select{
              width: 300px;
              height: 34px;
              background: transparent;
              border: none;
              // border-bottom: 1px solid rgba(120, 125, 233, 0.4);
              color: #D7DEFF;
              cursor: pointer;
              outline: none;
            }

          }
          &.list-address{
            input{
              margin-top: 33px;
              width: 300px;
              height: 34px;
              // padding: 0 10px;
              padding-bottom: 8px;
              border: none;
              border-bottom: 1px solid rgba(120, 125, 233, 0.4);
              background: transparent;
              font-size: 16px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #D7DEFF;
              letter-spacing: 1px;
              outline:none
            }
          }
          &.list-description{
            margin-top: 38px;
            height: 63px;
            textarea{
              width: 300px;
              height: 63px;
              // padding: 0 10px;
              padding-bottom: 8px;
              border: none;
              border-bottom: 1px solid rgba(120, 125, 233, 0.4);
              background: transparent;
              font-size: 16px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #D7DEFF;
              letter-spacing: 1px;
              outline:none
            }
          }
          &.list-img{
            margin-top: 32px;
            width: 177px;
            height: 91px;
          }
        }
        .capture-button{
          margin-top: 30px;
          width: 260px;
          height: 42px;
          background: url("~@/assets/img/schoolMonitorCenter/capture-dialog-button.png") center center no-repeat;
          background-size: 100% 100%;
          font-size: 18px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #D7DEFF;
          text-align: center;
          line-height: 42px;
          letter-spacing: 1px;
          cursor: pointer;
          position: relative;
          left: -68px;
        }
        input::-webkit-input-placeholder, textarea::-webkit-input-placeholder {
          color: rgba(215, 222, 255,0.8);
          font-size: 16px;
        }

        input:-moz-placeholder, textarea:-moz-placeholder {
          color: rgba(215, 222, 255,0.8);
          font-size: 16px;
        }

        input::-moz-placeholder, textarea::-moz-placeholder {
          color: rgba(215, 222, 255,0.8);
          font-size: 16px;
        }

        input:-ms-input-placeholder, textarea:-ms-input-placeholder {
          color: rgba(215, 222, 255,0.8);
          font-size: 16px;
        }
      }
    }
  }
}
</style>